// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5730) return "static/chunks/44530001-44ef19cfafa3c232.js";
	if (chunkId === 484) return "static/chunks/484-7cd026dbb86db281.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"167":"55f539740f45b090","2548":"f21142c15d4c120a"}[chunkId] + ".js";
};